import { RawDraftContentState } from "draft-js";
import { LocaleCode } from "shared/types/languages";

export type ArticleContent = {
  text: string;
  editorContent: RawDraftContentState | null;
};

export type Article = {
  id: string;
  version: string;
  updatedAt: Date;
  status: string;
  createdAt: Date;
  name: string;
  content: ArticleContent | null;
  language: string;
};

export type ArticleToCreate = {
  language: string;
  name: string;
};

export type ArticleToUpdate = {
  version: string;
  content: ArticleContent | null;
  updatedAt: Date;
  status: ArticleStatus;
  language: LocaleCode;
};

export enum ArticleStatus {
  PUBLISHED = "published",
  UNPUBLISHED = "unpublished",
}

export enum ArticleGroupIds {
  TERMS_OF_SERVICE = "termsConditions",
  PRIVACY_POLICY = "privacyPolicy",
  SELF_EXCLUSION = "selfExclusion",
}

export type ArticleBrand = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
};

export enum ArticleBrandId {
  INTERNATIONAL = "international",
  TELEGRAM = "telegram",
  FREE = "free",
}

export enum ArticleCategory {
  LEGAL = "legal",
  HELP = "help",
}

export type ArticleDocumentGroup = {
  id: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  languages: LocaleCode[];
};

export type CreateArticleDetailsParams = {
  brandId: ArticleBrandId;
  categoryId: ArticleCategory;
  groupId: ArticleGroupIds;
  article: ArticleToCreate;
};

export type DeleteArticleDetailsParams = {
  brandId: ArticleBrandId;
  categoryId: ArticleCategory;
  groupId: ArticleGroupIds;
  articleId: string;
};

export type UpdateArticleStatusParams = DeleteArticleDetailsParams & {
  status: ArticleStatus;
  language: LocaleCode;
};

export type UpdateArticleDetailsParams = DeleteArticleDetailsParams & {
  article: ArticleToUpdate;
};

export type CreateArticleDetailsResponse = {
  id: string;
};
